/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  DraftApplicationsService,
  IDraftApplicationsMethods,
  DeleteDraftService,
  IDeleteDraftMethods,
  IReinviteUserMethods,
  ReinviteUserService,
} from './plugins';

export type DraftAppPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IDraftApplicationsMethods &
  IReinviteUserMethods &
  IDeleteDraftMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new DraftApplicationsService(),
    new ReinviteUserService(),
    new DeleteDraftService(),
  ];
};

export const getAgent = () => {
  return createAgent<DraftAppPageAgent>({
    plugins: getPlugins(),
  });
};
